<div class="list-shell h-full flex">
  @if ($filteredHours().length) {
    <div class="content flex flex-1">
      <cdk-virtual-scroll-viewport
        itemSize="30"
        class="flex-1"
        minBufferPx="800"
        maxBufferPx="1000"
        (scroll)="resetCurrentBreak($event)"
      >
        <div class="line fake-line">
          <div class="cell hour h-4"></div>
          <div *ngFor="let x of [0, 1, 2, 3, 4, 5, 6]">
            <div class="cell h-4"></div>
          </div>
        </div>
        <div
          class="cell block md:hidden h-4 w-full"
          [class]="(userLang$ | async).indexOf('fr') < 0 ? 'ml-20' : 'ml-15'"
        ></div>
        <div
          class="line"
          *cdkVirtualFor="let hourOccurrence of $filteredHours(); templateCacheSize: 60"
        >
          <div class="cell hour text-black/50">
            <div class="hour-content flex items-center justify-end">
              <span class="pt-0.5">
                {{ hourOccurrence.startHour }}
              </span>
              <div class="dash"></div>
            </div>
          </div>
          <div
            *ngFor="let occurrences of hourOccurrence.occurrences; let i = index"
            class="cell"
          >
            <ng-container *ngFor="let occurrence of occurrences; let i = index">
              <ng-container *ngIf="getBreak(occurrence.breakId); let breakObj">
                <div
                  class="slot flex justify-between"
                  [style]="getSlotStyle(breakObj)"
                  [class.selected]="selectedIds.indexOf(occurrence.occurrenceId) > -1"
                  (click)="handleEventSelect(occurrence, breakObj, $event)"
                  (contextmenu)="onContextMenu(occurrence, breakObj, $event)"
                >
                  <div class="slot-title break-words min-w-0">{{ breakObj.name }}</div>
                  <div class="selected-icon">
                    <img [src]="getIconStyle(breakObj)" alt="selected icon" />
                  </div>
                  <div class="priority" *ngIf="occurrences.length > 1">P{{ i + 1 }}</div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  } @else {
    <div class="flex flex-col items-center justify-center gap-4 w-full">
      <img class="w-2/3" src="/assets/playlist-empty.svg" />
      <div class="font-semibold text-lg" translate>SCHEDULE.PLANNING.BREAK_EMPTY_DAY</div>
    </div>
  }
</div>
